<template>
  <component :is="layout">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </component>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { computed, onMounted, onBeforeMount } from 'vue';
import DefaultLayout from '@components/layout/DefaultLayout.vue';
import ClearLayout from '@components/layout/ClearLayout.vue';
import { AxiosAdapter, CommonAdapter } from '@adapters';
import { FetchCommonTotalUseCase } from '@core/useCases';
import { useCommonStore } from '@stores';

const axiosAdapter = new AxiosAdapter();
const commonAdapter = new CommonAdapter(axiosAdapter);
const fetchCommonTotalUseCase = new FetchCommonTotalUseCase(commonAdapter);
const commonStore = useCommonStore();
const route = useRoute();
const layout = computed(() =>
  route.meta.layout === 'ClearLayout' ? ClearLayout : DefaultLayout
);

const handleBeforeUnload = (e: BeforeUnloadEvent) => {
  if (!commonStore.isLoading) {
    return;
  }
  e.preventDefault();
};

onMounted(async () => {
  try {
    window.addEventListener('beforeunload', handleBeforeUnload);
    commonStore.setIsLoading(true);
    if (!commonStore.isTotalSystemInfo) {
      const data = await fetchCommonTotalUseCase.execute();
      if (data) {
        commonStore.setTotalSystemInfo(data);
      }
    }
  } catch (e) {
    console.error('Initial API calls failed:', e);
    // API 호출이 실패해도 화면은 렌더링되도록 함
  } finally {
    setTimeout(() => {
      commonStore.setIsLoading(false);
    }, 500);
    // (오션힐스랑 mounted 시 호출 api 가 달라 송추에서는 초기진입 시점 보장 필요) 초기 진입 로딩만 최소 500ms 보장
  }
});

onBeforeMount(() => {
  if (commonStore.isLoading) {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  }
});
</script>

<style scoped lang="scss">
.index {
  @apply mt-1 font-sans;
}
h1 {
  @apply pd-[31] mg-[10] fs-[22];
}
</style>
